export type DownTimeType = 'include' | 'exclude'

export const defaultStatus = {
  previousStatus: 'under_repair',
  newStatus: 'active',
}
export interface Incidences {
  id: number
  category: string
  externalReference?: string | null
  zendeskId?: string | null
  duration: string
  downtime: string
  notes?: string | null
  createdBy?: string | null
  updatedBy?: string | null
  listingTitle: string
  rootCause?: string | null
  startTime: string
  resolution?: string | null
  endTime?: string | null
}

export interface UpdateIncidenceParams {
  zendesk_id?: string
  root_cause_id: number
  resolution_id?: number
  downtime: string
  end_time?: string
  start_time: string
}
